export default "__VITE_ASSET__DvHhvXw0__"